import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faPhone, 
  faEnvelope, 
  faLocationDot,
  faClock
} from '@fortawesome/free-solid-svg-icons';
import { 
  faFacebook, 
  faInstagram, 
  faLinkedin 
} from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo e descrizione */}
        <div className="footer-section">
          <div className="footer-logo">
            <img src={require("../assets/logos/0001.png")} alt="Logo" className="footer-logo-image" />
          </div>
          <p className="footer-description">
            Specialista in Otorinolaringoiatria con oltre 10 anni di esperienza 
            nella diagnosi e cura delle patologie di orecchio, naso e gola.
          </p>
        </div>

        {/* Link Rapidi */}
        <div className="footer-section">
          <h4 className="footer-heading">Link Rapidi</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/visite">Visite</Link></li>
            <li><Link to="/esami">Esami</Link></li>
            <li><Link to="/servizi">Servizi</Link></li>
            <li><Link to="/centro-convenzionato">Centro Convenzionato</Link></li>
            <li><Link to="/chi-sono">Chi Sono</Link></li>
            <li><Link to="/contatti">Contatti</Link></li>
          </ul>
        </div>

        {/* Contatti */}
        <div className="footer-section">
          <h4 className="footer-heading">Contatti</h4>
          <ul className="footer-contacts">
            <li>
              <FontAwesomeIcon icon={faPhone} className="footer-icon" />
              <a href="tel:+393701627395">+39 370 162 7395</a>
            </li>
            <li>
              <FontAwesomeIcon icon={faPhone} className="footer-icon" />
              <a href="tel:+390917669253">+39 091 766 9253</a>
            </li>
            <li>
              <FontAwesomeIcon icon={faEnvelope} className="footer-icon" />
              <a href="mailto:centrodiotorino.mattina@gmail.com">centrodiotorino.mattina@gmail.com</a>
            </li>
            <li>
              <FontAwesomeIcon icon={faLocationDot} className="footer-icon" />
              <a href="https://maps.google.com/?q=Via+Capo+dell'Acqua+6,+Piazza+Duomo,+Partinico" target="_blank" rel="noopener noreferrer">Via Capo dell'Acqua 6 (Piazza Duomo), Partinico</a>
            </li>
          </ul>
        </div>

        {/* Orari */}
        <div className="footer-section">
          <h4 className="footer-heading">Orari</h4>
          <ul className="footer-hours">
            <li>
              <FontAwesomeIcon icon={faClock} className="footer-icon" />
              <div>
                <div>Lunedì</div>
                <div className="footer-hours-time">09:00 - 13:00</div>
              </div>
            </li>
            <li>
              <FontAwesomeIcon icon={faClock} className="footer-icon" />
              <div>
                <div>Mercoledì</div>
                <div className="footer-hours-time">09:00 - 13:00 / 15:00 - 19:00</div>
              </div>
            </li>
            <li>
              <FontAwesomeIcon icon={faClock} className="footer-icon" />
              <div>
                <div>Venerdì</div>
                <div className="footer-hours-time">09:00 - 13:00 / 15:00 - 19:00</div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      {/* Social e Copyright */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <div className="footer-social">
            <a href="https://www.facebook.com/share/1AktcsfVdp/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href="https://www.instagram.com/gianfranco.mattina.otorino?igsh=Y3ZuMjkyN2d6em1w&utm_source=qr" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://www.linkedin.com/in/gianfranco-mattina-b2775b8a?utm_source=share_via&utm_content=profile&utm_medium=member_ios" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
          </div>

          <div className="footer-copyright">
            © 2026 Centro di Otorinolaringoiatria Mattina. Tutti i diritti riservati.
          </div>

          <div className="footer-policies">
            <Link to="/privacy-policy">Privacy & Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
